import * as Yup from 'yup';
import i18next from "../../i18n/i18n";

export const SIGN_IN_FIELD_LIMITS = {
    email: 50,
    password: 128,
};

export const state = { email: "", password: "" };

const validationMessage = (key, options) => () =>
    i18next.t(`homeAuthPages:${key}`, options);

export const schema = Yup.object().shape({
    email: Yup.string()
        .trim()
        .required(validationMessage("email_required"))
        .email(validationMessage("invalid_email"))
        .max(
            SIGN_IN_FIELD_LIMITS.email,
            validationMessage("email_max_length", {
                count: SIGN_IN_FIELD_LIMITS.email,
            })
        ),
    password: Yup.string()
        .required(validationMessage("password_required"))
        .max(
            SIGN_IN_FIELD_LIMITS.password,
            validationMessage("password_max_length", {
                count: SIGN_IN_FIELD_LIMITS.password,
            })
        )
});

